module.exports = __webpack_public_path__ + "7cacc89c76bbfc812f618b92dedc0d40.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/neusta.svg
// module id = 941
// module chunks = 0